import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, Button, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import RoleServices from '../../services/RoleServices';
import UserServices from '../../services/UserServices';

const Profile = () => {
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [lastPassword, setLastPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [passwordsMatch, setPasswordsMatch] = useState(true);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const [profile, setProfile] = useState({
        id: null,
        first_name: '',
        username: '',
        last_name: '',
        email: "",
        role_id: "",
        phone: "",
        password: ""
    });
    const [roles, setRoles] = useState([]);
    const username = localStorage.getItem('username');

    useEffect(() => {
        UserServices.getUser(username).then(data => {
            setProfile(data['data']);
        });

        RoleServices.getRoles().then(data => {
            setRoles(data['data']);
        });
    }, [username]);

    const showRoleTitle = (roleId) => {
        const role = roles.filter((r) => r.id === roleId);
        let element;
        if (typeof role[0] !== 'undefined') {
            element = role[0];
        } else {
            element = {
                title: " "
            }
        }
        return element.title;
    };

    const toggleChangePassword = () => {
        setShowChangePassword(!showChangePassword);
    };

    const handleLastPasswordChange = (e) => {
        setLastPassword(e.target.value);
    };

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
        if (e.target.value !== confirmNewPassword) {
            setPasswordsMatch(false);
        } else {
            setPasswordsMatch(true);
        }
    };

    const handleConfirmNewPasswordChange = (e) => {
        setConfirmNewPassword(e.target.value);
        if (e.target.value !== newPassword) {
            setPasswordsMatch(false);
        } else {
            setPasswordsMatch(true);
        }
    };

    const handleSubmitChangePassword = (e) => {
        e.preventDefault();
        if (newPassword.trim() === "") {
            setAlert("Veuillez remplir tous les champs.");
            return false;
        }
        // Ajouter ici le code pour soumettre le formulaire et mettre à jour le mot de passe
        const newProfile = {
            password: newPassword,
            password_confirmation: confirmNewPassword,
            old_password: lastPassword
        };
        UserServices
            .updateUserPassword({ ...profile, ...newProfile })
            .then(data => {
                console.log(data);
                if (data['success'] === true) {
                    setLastPassword('');
                    setNewPassword('');
                    setConfirmNewPassword('');
                    setPasswordsMatch(true);
                    setShowChangePassword(false);
                    setAlert("");
                    setMessage("Le mot de passe a été changé avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };


    return (
        <Container className="mt-4">
            <Row>
                <Col md="6">
                    <Card>
                        <CardBody>
                            <CardTitle className="text-center">Profil</CardTitle>

                            {message && <div className="alert alert-success mt-1">{message}</div>}
                            {alert && <div className="alert alert-danger mt-1">{alert}</div>}
                            <p><strong>Email:</strong> {profile.email}</p>
                            <p><strong>Tél:</strong> {profile.phone}</p>
                            <p><strong>Prénom:</strong> {profile.first_name}</p>
                            <p><strong>Nom:</strong> {profile.last_name}</p>
                            <p><strong>Rôle:</strong> {showRoleTitle(profile.role_id)}</p>
                            <Button onClick={toggleChangePassword} className="mt-4">Modifier le mot de passe</Button>
                            {showChangePassword && (
                                <Form className="mt-4" onSubmit={handleSubmitChangePassword}>
                                    <FormGroup>
                                        <Label for="lastPassword">Ancien mot de passe</Label>
                                        <Input type="password"
                                            name="lastPassword"
                                            id="lastPassword"
                                            value={lastPassword}
                                            onChange={handleLastPasswordChange}
                                            required={true} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="newPassword">Nouveau mot de passe</Label>
                                        <Input type="password"
                                            name="newPassword"
                                            id="newPassword"
                                            value={newPassword}
                                            onChange={handleNewPasswordChange}
                                            required={true}
                                            invalid={!passwordsMatch} />
                                        {!passwordsMatch && <FormFeedback>Les mots de passe ne correspondent pas</FormFeedback>}
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="confirmNewPassword">Confirmer le nouveau mot de passe</Label>
                                        <Input type="password"
                                            name="confirmNewPassword"
                                            id="confirmNewPassword"
                                            value={confirmNewPassword}
                                            onChange={handleConfirmNewPasswordChange}
                                            required={true}
                                            invalid={!passwordsMatch} />
                                        {!passwordsMatch && <FormFeedback>Les mots de passe ne correspondent pas</FormFeedback>}
                                    </FormGroup>
                                    <Button type="submit">Sauvegarder</Button>
                                    <Button onClick={toggleChangePassword} className="ml-2">Annuler</Button>
                                </Form>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
export default Profile;